var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-ss-moon",
    clipPath: "url(#clip0_969_4721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.25629 16.0352C7.25854 16.033 5.34324 15.2385 3.93062 13.8258C2.518 12.4132 1.72345 10.4979 1.72128 8.50019C1.62521 2.87656 8.01992 -0.909146 12.8926 1.91271L13.8677 2.45398L12.8988 3.00654C8.69179 5.3223 8.99947 11.7157 13.4012 13.6221L14.419 14.0811L13.4979 14.7128C12.2504 15.5727 10.7714 16.0338 9.25629 16.0352Z",
    fill: "#007AF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_969_4721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.07,
    height: 15.07,
    fill: "white",
    transform: "translate(0.465332 0.964966)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.0ffb266de55fd6c5aadb153af2fca549.svg";
export { ForwardRef as ReactComponent };